import { z } from "zod";





/**
 * Weight Loss Progress validation schema
 * Validates the entire weightLossProgress category
 */

const responseDetailSchema = z.object({
  response: z.boolean(),
  description: z.string().optional(),
});

export const weightLossProgressValidation = z.object({
  weightLossProgress: z.string().min(1, "Please enter your feedback"),
  changesInSleep: responseDetailSchema,
  additionalComments: z.string().min(1, "Please enter your comments"),
});

export default weightLossProgressValidation;